import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../../shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-associate-estimates-dialog',
  templateUrl: './associate-estimates-dialog.component.html',
  styleUrls: ['./associate-estimates-dialog.component.css']
})
export class AssociateEstimatesDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput1: boolean = false;
  errorMessage1: string = '';
  selectOptions: any = [];

  formGroup1: any;

  constructor(
    public dialogRef: MatDialogRef<AssociateEstimatesDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.local_data.associatedNames.push(this.variables.other);

    if (this.data?.type === 'edit') {
      this.formGroup1 = this._formBuilder.group({
        firstCtrl: [this.local_data.element.name, Validators.required],
        customValueCtrl: ['']
      });
    }
    else {
      this.formGroup1 = this._formBuilder.group({
        firstCtrl: ['', Validators.required],
        customValueCtrl: ['']
      });
    }
  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    /* Check if all the inputs have been filled. */
    if (formGroup.firstCtrl === '' || formGroup.firstCtrl === undefined) {
      this.invalidInput1 = true;
      this.errorMessage1 = this.variables.errorNameUser;
      valid = false;
    }

    if (formGroup.firstCtrl === this.variables.other) {
      if (formGroup.customValueCtrl === '' || formGroup.customValueCtrl === undefined) {
        this.invalidInput1 = true;
        this.errorMessage1 = this.variables.errorNameUser;
        valid = false;
      }
    }

    if (formGroup.firstCtrl) {
      if (formGroup.firstCtrl == this.variables.other) {
        this.local_data.name = formGroup.customValueCtrl;
      }
      else {
        this.local_data.name = formGroup.firstCtrl;
      }
    }

    //Pass data
    if (valid) this.dialogRef.close({ data: this.local_data });
  }

}

